import logo from "./logo.svg";
import "./App.css";
import { useState } from "react";

function App() {
  const styles = {
    container: {
      width: "50%",
      margin: "auto",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
    input: {
      width: "100%",
      padding: "12px",
      margin: "6px 0",
      display: "inline-block",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      borderRadius: "8px",
    },
    button: {
      width: "100%",
      backgroundColor: "#347AF0",
      color: "white",
      padding: "14px 20px",
      margin: "8px 0",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
    },
    successContainer: {
      display: "block",
      padding: "4px 8px",
      backgroundColor: "green",
      color: "white",
      borderRadius: "8px",
    },
    successMessage: {
      fontSize: "13px",
      fontWeight: "bold",
    },
    logo:{
      alignSelf:"flex-start"
    }
  };
  const [isSuccess, setIsSuccess] = useState(false);
  return (
    <div style={styles.container}>
      <img src={logo} className="App-logo" style={styles.logo} alt="logo" />
      <h1 style={{alignSelf:"flex-start"}}>Contact Us</h1>
      <h3 style={{alignSelf:"flex-start"}}>CryptEdu - E-Learning Platform</h3>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          setIsSuccess(true);
        }}
      >
        <input
          required
          style={styles.input}
          type="text"
          placeholder="Enter your name"
        />
        <input
          required
          style={styles.input}
          type="email"
          placeholder="Enter your email"
        />
        <textarea
          required
          style={styles.input}
          placeholder="Enter your message"
        ></textarea>
        <button style={styles.button}>Submit</button>
      </form>

      {isSuccess && (
        <div style={styles.successContainer}>
          <p style={styles.successMessage}>
            Your message has been sent to our support center, We will contact
            you as soon as possible.
          </p>
        </div>
      )}
    </div>
  );
}

export default App;
